import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { CnCodeQuery, CnCodeQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(CnCodeQuery)
@Wrapper(CnCodeQueryHandlerBase)
export class CnCodeQueryHandler {
    public constructor(
        http: Http
    ) { }
}
